// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"64":"e9a3bc07","769":"d3d5afde"}[chunkId] + ".chunk.css";
};